module.exports = __webpack_public_path__ + "img/w3_circle_trash_check_black.bf9f9796.png";